import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
    CheckCircle as CheckCircleIcon,
    Close as CloseIcon,
    DoneOutlined as Done,
    Error as ErrorIcon,
    Info as InfoIcon
} from '@material-ui/icons';
import {IconButton, Snackbar, SnackbarContent} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import {makeStyles} from '@material-ui/core/styles';

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
};

const useStyles = makeStyles(theme => ({
    success: {
        backgroundColor: "#4caf50 !important",
    },
    error: {
        backgroundColor: "#d32f2f !important"
    },
    info: {
        backgroundColor: "#2196f3 !important",
    },
    warning: {
        backgroundColor: "#ff9800 !important",
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1),
    },
    message: {
        display: 'flex',
        alignItems: 'center',
        overflowY: "auto",
        maxHeight: "90vh"
    },
}));

function MySnackbarContentWrapper(props) {
    const classes = useStyles();
    const {className, message, onClose, onSubmit, variant, ...other} = props;
    const Icon = variantIcon[variant];

    let actions = [];
    if (onSubmit) {
        actions.push(
            <IconButton key="apply" aria-label="close" color="inherit" onClick={onSubmit}>
                <Done className={classes.icon}/>
            </IconButton>
        )
    }
    actions.push(
        <IconButton key="close" aria-label="close" color="inherit" onClick={onClose}>
            <CloseIcon className={classes.icon}/>
        </IconButton>
    );

    return (
        < SnackbarContent
            className={clsx(classes[variant], className)}
            aria-describedby="client-snackbar"
            message={
                <span id="client-snackbar" className={classes.message}>
                    <Icon className={clsx(classes.icon, classes.iconVariant)}/>
                    {message}
                 </span>
                      }
            action={actions}
            {...other}
        />
    );
}

MySnackbarContentWrapper.propTypes = {
    className: PropTypes.string,
    message: PropTypes.node,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    variant: PropTypes.oneOf(['error', 'info', 'success', 'warning']).isRequired,
};


export default function NotificationPopup(props) {
    const {open, variant, message, onClose, onSubmit} = props;

    return (
        <Snackbar
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            open={open}
            autoHideDuration={90000}
            onClose={onClose}
        >
            <MySnackbarContentWrapper
                onClose={onClose}
                onSubmit={onSubmit}
                variant={variant}
                message={message}
            />
        </Snackbar>
    )
}

NotificationPopup.propTypes = {
    open: PropTypes.bool,
    message: PropTypes.node,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    variant: PropTypes.oneOf(['error', 'info', 'success', 'warning']).isRequired,
};
